<div class="container species-container">

  <h3 i18n class="display-6 species-header"
    align="center">
    {displayedTitle, select, Add Species {Add Species} Edit Species {Edit Species}}
  </h3>

  <form [formGroup]="speciesForm" (keydown.enter)="onEnter($event)">

    <!-- Select species name -->
    <div class="row">

      <h6 i18n class="species-small-header">
        Species Name
      </h6>
      <mat-form-field appearance="fill">
        <mat-label i18n>
          Species
        </mat-label>
        <input matInput
          #speciesInput
          required
          formControlName="speciesName"
          [matAutocomplete]="auto"
          [readonly]="speciesIsReadOnly">
          <mat-autocomplete #auto="matAutocomplete">
            @for (fSpecies of filteredSpecies; track fSpecies) {
              <mat-option i18n
                [value]="fSpecies">
            {fSpecies, select,
            Sockeye {Sockeye}
            Coho (Silver) {Coho (Silver)}
            Pink (Humpy) {Pink (Humpy)}
            Chum (Dog) {Chum (Dog)}
            Chinook (Smiley, King) {Chinook (Smiley, King)}
            Legal Sized Chinook (Smiley, King) {Legal Sized Chinook (Smiley, King)}
            Sublegal Sized Chinook (Smiley, King) {Sublegal Sized Chinook (Smiley, King)}
            Adult Chinook (Smiley, King) {Adult Chinook (Smiley, King)}
            Jack Chinook (Jack Spring, Jax) {Jack Chinook (Jack Spring, Jax)}
            Steelhead {Steelhead}
            Atlantic {Atlantic}
            Salmonids {Salmonids}
            American Shad {American Shad}
            Arrowtooth Flounder (Turbot) {Arrowtooth Flounder (Turbot)}
            Black Rockfish (Black Bass, Sea Bass) {Black Rockfish (Black Bass, Sea Bass)}
            Black Skipjack {Black Skipjack}
            Bocaccio {Bocaccio}
            Canary Rockfish {Canary Rockfish}
            China Rockfish (Yellowstripe) {China Rockfish (Yellowstripe)}
            Chub Mackerel {Chub Mackerel}
            Codfishes {Codfishes}
            Copper Rockfish {Copper Rockfish}
            Dolly Varden {Dolly Varden}
            Dover Sole {Dover Sole}
            Flatfishes {Flatfishes}
            Greenlings {Greenlings}
            Greenstriped Rockfish {Greenstriped Rockfish}
            Jack Mackerel {Jack Mackerel}
            Lampreys {Lampreys}
            Lefteye Flounders {Lefteye Flounders}
            Lingcod {Lingcod}
            Pacific Cod (Gray Cod) {Pacific Cod (Gray Cod)}
            Pacific Hake {Pacific Hake}
            Pacific Halibut {Pacific Halibut}
            Pacific Ocean Perch {Pacific Ocean Perch}
            Pacific Sardine (Pilchard) {Pacific Sardine (Pilchard)}
            Pacific Tomcod (Tommy) {Pacific Tomcod (Tommy)}
            Quillback Rockfish {Quillback Rockfish}
            Ratfishes {Ratfishes}
            Redstripe Rockfish {Redstripe Rockfish}
            Righteye Flounders {Righteye Flounders}
            Sablefishes (Black Cod) {Sablefishes (Black Cod)}
            Sculpins (Bullheads) {Sculpins (Bullheads)}
            Sea Cucumbers {Sea Cucumbers}
            Silvergray Rockfish {Silvergray Rockfish}
            Skipjack Tuna {Skipjack Tuna}
            Southern Rock Sole {Southern Rock Sole}
            Spiny Dogfish (Dog Shark) {Spiny Dogfish (Dog Shark)}
            Starry Flounder {Starry Flounder}
            Sturgeons {Sturgeons}
            Tiger Rockfish {Tiger Rockfish}
            Walleye Pollock {Walleye Pollock}
            Widow Rockfish (Brown Bomber) {Widow Rockfish (Brown Bomber)}
            Yelloweye Rockfish {Yelloweye Rockfish}
            Yellowtail Rockfish {Yellowtail Rockfish}
            }
          </mat-option>
          }
        </mat-autocomplete>
        @if (speciesForm.invalid) {
          <mat-error i18n>
          Select an item
        </mat-error>
        }
      </mat-form-field>

    </div>

    <!-- Daily Catch Report Fields -->

    @if (tableInfo.tableType === 'daily-catch') {
      <div>
        <!-- Kept Catch -->
        @if (!catchService.isReleaseOnly(getCurrentFormSpecies(), tableInfo)) {
          <div
            class="row">
            <h6 i18n class="species-small-header">
          Kept
        </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
            Kept
          </mat-label>
              <input matInput
                #keptInput
                maxlength="5"
                inputmode="numeric"
                formControlName="kept"
                autocomplete="off"
                (input)="sharedMethodsService.forbidNonNumeric('kept', speciesForm)">
              </mat-form-field>
            </div>
          }
          <!-- Released Catch -->
          <div class="row">
            <h6 i18n class="species-small-header">
          Released
        </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
            Released
          </mat-label>
              <input matInput
                maxlength="5"
                inputmode="numeric"
                formControlName="released"
                autocomplete="off"
                (input)="sharedMethodsService.forbidNonNumeric('released', speciesForm)">
              </mat-form-field>
            </div>
          </div>
        }

        <!-- Offload Catch Report Fields -->

        @if (tableInfo.tableType === 'offload-catch') {
          <div>
            <!-- Weight (Seine only) -->
            @if (tableInfo.gearName === 'Seine') {
              <div
                class="row">
                <h6 i18n class="species-small-header">
          Weight
        </h6>
                <mat-form-field appearance="fill">
                  <mat-label i18n>
            Weight
          </mat-label>
                  <input matInput
                    maxlength="32"
                    inputmode="numeric"
                    formControlName="offloadWeight"
                    (input)="sharedMethodsService.forbidNonNumeric('offloadWeight', speciesForm)">
                  </mat-form-field>
                </div>
              }
              <!-- Pieces -->
              <div class="row">
                <h6 i18n class="species-small-header">
          Pieces
        </h6>
                <mat-form-field appearance="fill">
                  <mat-label i18n>
            Pieces
          </mat-label>
                  <input matInput
                    maxlength="32"
                    inputmode="numeric"
                    formControlName="offloadPieces"
                    (input)="sharedMethodsService.forbidNonNumeric('offloadPieces', speciesForm)">
                  </mat-form-field>
                </div>
              </div>
            }

          </form>

          <!-- Release-only species descriptive text -->

          @if (catchService.isReleaseOnly(getCurrentFormSpecies(), tableInfo)) {
            <div
              class="row">
              <h6 i18n class="species-small-header">
      This species is non-retainable.
    </h6>
            </div>
          }

          <!-- Add & Delete Buttons -->

          <div style="display: flex; justify-content: space-around; margin-bottom: 15px;">
            <button i18n mat-stroked-button
              class="button-delete"
              type="button"
              aria-label="Delete"
              (click)="deleteSpecies()">
      Delete
    </button>

            <button i18n mat-stroked-button
              class="button-add"
              type="submit"
              align="end"
              aria-label="Add Species"
              (click)="addSpecies()">
      Confirm
    </button>

          </div>
        </div>
